import { createActionType } from '../../helpers'

export const LOAD_LAYOUT = createActionType('HOME_LAYOUT', 'FETCH')
export const UPDATE_LAYOUT = createActionType('HOME_LAYOUT', 'UPDATE')
